import { render, staticRenderFns } from "./RegPrasymasInformavimasAsmenys.vue?vue&type=template&id=45bfb65b&scoped=true&"
import script from "./RegPrasymasInformavimasAsmenys.vue?vue&type=script&lang=js&"
export * from "./RegPrasymasInformavimasAsmenys.vue?vue&type=script&lang=js&"
import style0 from "./RegPrasymasInformavimasAsmenys.vue?vue&type=style&index=0&id=45bfb65b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bfb65b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VDivider,VRow})
